<template>
  <div>
    <el-form ref="personform" label-position="right" label-width="120px" :model="formLabelAlign" status-icon :rules="rules">
            <el-row>
              <el-form-item label="简述">
                <el-input type="textarea" v-model="formLabelAlign.paper" autocomplete="off"></el-input>
              </el-form-item>
            </el-row>
            <el-row>
              <el-form-item prop="file" ref="uploadpic">
                <el-upload
                  style="display:inline-block"
                  :limit="2"
                  class="upload-demo"
                  ref="upload"
                  action="/hqx/knowledge/importKnowledge"
                  :before-upload="beforeAvatarUpload"
                  :auto-upload="false"
                  :on-change="imageChange"
                  :on-remove="imageRemove"
                >
                  <el-button slot="trigger" size="small" type="primary" plain>上传</el-button>
                </el-upload>
              </el-form-item>
            </el-row>
			<el-form-item style="margin-top: 30px;">
				<el-button type="primary" style="width: auto;" @click="confirm">提交</el-button>
			</el-form-item>
          </el-form>
</div>
 
</template>
 
<script>
export default {
	  data() {
	    return {
	      xiugai: false,
	      formLabelAlign: {
	        paper: ""
	      },
	      images: [],// 图片存储
	      rules: {
	        file: [{ required: true, message: "请上传图片", trigger: "change" }]
	      },
	      haspic: false // 默认没有传图片
	    };
	  },
	  methods: {
	    beforeAvatarUpload(file) {
	      // 文件类型进行判断
	      const isJPG = /^image\/(jpeg|png|jpg)$/.test(file.type);
	      const isLt2M = file.size / 1024 / 1024 < 2;
	      if (!isJPG) {
	        this.$message.error("上传图片只能是 image/jpeg/png 格式!");
	      }
	      if (!isLt2M) {
	        this.$message.error("上传图片大小不能超过 2MB!");
	      }
	      return isJPG && isLt2M;
	    },
	    imageChange(file, fileList, name) {//on-change触发
	      this.images["file"] = fileList;
	      this.haspic = true;
	      // 如果上传了就不显示提示图片警告
	      if (typeof this.images.file != "undefined") {
	        if (this.images.file.length > 0) {
	          this.$refs["uploadpic"].clearValidate();
	        }
	      }
	    },
	    imageRemove(file, fileList, name) { //on-remove触发
	    //如果images为空了说明并没有提交图片所以需要显示警告
	      if (typeof this.images.file != "undefined") {
	        if (this.images.file.length > 0) {
	          this.$refs["uploadpic"].clearValidate();
	        } else {
	          this.$refs["uploadpic"].validate();
	          this.haspic = false;
	        }
	      }
	    },
	    confirm() {// 提交绑定的事件
	      if (this.haspic) {
	        // 去掉rules中对图片的验证
	        _.unset(this.rules, ["file"]);
	        this.$refs["personform"].validate(valid => {
	          if (valid) {
	            console.log("说明已经添加了图片直接提交就行了");
	            const wfForm = new FormData();
	              wfForm.append( 'dsc',this.formLabelAlign.paper)
	              Object.entries(this.images).forEach(file => {
	                  file[1].forEach(item => {
	                  wfForm.append('files', item.raw)
	                  wfForm.append(item.name, file[0])
	                  })
	              })
	              // 直接提交
	          } else {
	            console.log("error submit!!");
	            return false;
	          }
	        });
	      } else {
	        // 向rules提价一条对图片的验证。
	        _.set(this.rules, "file", { required: true, message: "请上传图片", trigger: "change"});
	        this.$refs["personform"].validate(valid => {
	          if (valid) {
	            console.log("说明图片没有提交");
	          } else {
	            console.log("error submit!!");
	            return false;
	          }
	        });
	      }
	    }
	  }
	};
  
</script>

<style>
</style>
